<script setup lang="ts">
/*
 * @descriptions: 原始数据确认弹窗
 */
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import common from '@/utils/common'
import Cookies from 'js-cookie'
import { useUserStore } from '@/store/modules/user'
import { storeToRefs } from 'pinia'

// router使用
const router = useRouter()

// pinia使用
const userStore = useUserStore()
const { businessId } = storeToRefs(userStore)

// 数据初始化
const dialogVisible = ref(false)

const handleClose = () => {
  dialogVisible.value = false
  Cookies.set('contractReadVisible', '1')
}
const handleSure = () => {
  handleClose()
  dialogVisible.value = false
  router.push({
    name: 'ContractInfoDetail',
    query: { businessId: businessId.value, status: 1 }
  }) // 跳转到合同立项信息详情页面
}

// 父子数据传递
const $props = defineProps({
  contractStr: {
    type: String
  }
})

// 暴露组件的属性和方法
defineExpose({
  dialogVisible
})
</script>

<template>
  <el-dialog
    draggable
    :close-on-click-modal="false"
    v-model="dialogVisible"
    title="温馨提示"
    width="640"
    align-center
    :before-close="handleClose"
  >
    <div class="sure-tip">
      <p class="mb5">
        <i class="el-icon-message-solid f20 mr10 orange"></i>尊敬的老师，您好！
      </p>
      <p>
        您的项目
        <span class="bold">“ {{ $props.contractStr }} ”</span>
        即将在我司立项，请您对合同的主要信息进行查阅，如有变动请联系销售同事进行沟通。
      </p>
    </div>
    <template #footer>
      <div class="dialog-footer text-center">
        <el-button type="primary" @click="handleSure"> 立即前往确认 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped></style>
